module.exports = __webpack_public_path__ + "img/banner_generic_left.95b1aca7.jpg";